const BreadData = [
  {
    productname: "Plain Bread",
    productdescription:
      "PSO bread is made from whole wheat flour and are perfect for all types of sandwiches! We hope you enjoy eating it as much as we enjoyed baking it.",
  },
  {
    productname: "Sweet Bread",
    productdescription:
      "This delectable sweet bread is the perfect combination of wheat flour, millets, pearl (bajra) and jawar. It's hearty with a spin of healthy.",
  },
  {
    productname: "Millet Bread",
    productdescription:
      "PSO fruit bread is made with the goodness of whole wheat, soya flour and millet. Goes well with tea or coffee.",
  },
];
export default BreadData;
